import { render, staticRenderFns } from "./PanRemoveDialog.vue?vue&type=template&id=4a3c04b9&scoped=true"
import script from "./PanRemoveDialog.vue?vue&type=script&lang=js"
export * from "./PanRemoveDialog.vue?vue&type=script&lang=js"
import style0 from "./PanRemoveDialog.vue?vue&type=style&index=0&id=4a3c04b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c04b9",
  null
  
)

export default component.exports